export { default } from "./Privacy";
